"use client";

import { useEffect } from "react";

export default function BookedSolidChat({ clientId, autoOpen = false }) {
  const resolvedClientId =
    clientId || process.env.NEXT_PUBLIC_BOOKEDSOLID_CLIENT_ID || "";
  const isDev = process.env.NODE_ENV !== "production";

  useEffect(() => {
    if (!resolvedClientId && isDev) {
      console.warn("BookedSolid chat widget skipped: client ID missing.");
    }
  }, [resolvedClientId, isDev]);

  useEffect(() => {
    if (!resolvedClientId) return;

    const widgetSrc = "https://dashboard.bookedsolid.co.uk/widget.js";
    const scriptId = "bookedsolid-widget";
    const initFlag = "__bookedSolidChatWidgetInitialized";
    let cancelled = false;
    let attempts = 0;
    const maxAttempts = 50;

    const ensureScriptPresent = () => {
      if (document.getElementById(scriptId)) {
        return;
      }

      const script = document.createElement("script");
      script.id = scriptId;
      script.src = widgetSrc;
      script.async = true;
      document.body.appendChild(script);
    };

    const initChatWidget = () => {
      if (cancelled || window[initFlag]) return;

      if (window.ChatWidget && typeof window.ChatWidget.init === "function") {
        window.ChatWidget.init({
          clientId: resolvedClientId,
          theme: "light",
          position: "bottom-right",
          autoOpen: false,
          title: "Virtual Assistant",
          welcomeMessage: "Hi there! How can I help you today?",
        });
        window[initFlag] = true;
        return;
      }

      if (attempts < maxAttempts) {
        attempts += 1;
        setTimeout(initChatWidget, 200);
      }
    };

    ensureScriptPresent();
    initChatWidget();

    return () => {
      cancelled = true;
    };
  }, [resolvedClientId, autoOpen]);

  if (!resolvedClientId) {
    return null;
  }

  return null;
}
